import { ApplicationInsights, IConfiguration, IEventTelemetry } from '@microsoft/applicationinsights-web';




let appInsights: ApplicationInsights | undefined = undefined;

if (process.env.REACT_APP_TELEMETRY_KEY) {

  try {

    const config: IConfiguration = {
      instrumentationKey: process.env.REACT_APP_TELEMETRY_KEY,
    };

    appInsights = new ApplicationInsights({
      config
    });

    appInsights.loadAppInsights();

  } catch (error) {
  }
}




const setAuthenticatedUser = (authenticatedUserId: string, accountId?: string) => {
  if (
    appInsights
  ) {
    appInsights.setAuthenticatedUserContext(authenticatedUserId);
  }
};




const createEvent = (event: IEventTelemetry) => {

  if (
    process.env.NODE_ENV === 'production' &&
    appInsights
  ) {

    try {

      appInsights.trackEvent(event);
      appInsights.flush();

    } catch (error) {
    }
  }
};




enum WsAnalyticsEventType {
  PortalLoad     = "PORTAL_LOAD",
  PortalNavigate = "PORTAL_NAVIGATE"
}




export {
  WsAnalyticsEventType,
  setAuthenticatedUser,
  createEvent
};
